import { Collection } from "../../models/Collection";

export function getAllCollections(openCollections: Collection[], closedCollections: Collection[]): Collection[] {
    const filteredOpenCollections: Collection[] = []
    openCollections.forEach(element => {
        const coll = closedCollections.find(x => x.collectionUid === element.collectionUid)
        if(!coll){
            filteredOpenCollections.push(element)
        }
    });
    
    const allCollections = filteredOpenCollections.concat(closedCollections)
    return allCollections
}